require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-postnatal-return-to-exercise.json") })
        }
      }, "path---blog-postnatal-return-to-exercise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-postnatal-return-to-exercise!./.cache/json/blog-postnatal-return-to-exercise.json
// module id = 303
// module chunks = 231608221292675